/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import type {
    AIRuleResponse,
    AccountingMethodResponse,
    ActivateTenantRequest,
    ActivateTenantResponse,
    AddRuleBankParams,
    AddUserToTenantParams,
    AdminGetAllUsersParams,
    ApplicationVersionResponse,
    ApplyManualFixedAssetRuleRequest,
    ApplyManualFixedAssetSplitsRequest,
    ApplyManualProjectSplitsRequest,
    AuditLogResponse,
    AvaibleUserInTenantResponse,
    CleanseFileResponse,
    CommitImportRequest,
    CommitImportResponse,
    CommitProjectDataImportRequest,
    CommitProjectDataImportResponse,
    CommitRuleImportRequest,
    CommitRuleImportResponse,
    ContactPersonResponse,
    CreateApplicationContactRequest,
    CreateColumnsRequest,
    CreateDatasetColumnsParams,
    CreateEntityRequest,
    CreateImportFromCleansedFileParams,
    CreatePoolRequest,
    CreateProjectRequest,
    CreateRuleRequest,
    CreateTenantContactRequest,
    CreateTenantRequest,
    CreateTenantResponse,
    CreateTimePeriodRequest,
    CreateUserParams,
    CurrentUserTenantResponse,
    DataColumnResponse,
    DataFieldDefinitionResponse,
    DataGridResponse,
    DatabricksRunStatusResponse,
    DeletePoolParams,
    DeleteProjectParams,
    EditContactPersonRequest,
    EditPolicyRequest,
    EditTenantRequest,
    EditUserRequest,
    EntitiesUnlinkedResponse,
    EntityHasRulesParams,
    EntityResponse,
    GetAIRulesParams,
    GetAllUsersParams,
    GetAuditLogParams,
    GetCleanseFilesParams,
    GetDataFieldDefinitionsParams,
    GetDataGridParams,
    GetDatasetColumnsParams,
    GetFAProgressBarStatusParams,
    GetGeneratedFixedAssetRulesParams,
    GetPoolsParams,
    GetProjectProgressBarStatusParams,
    GetProjectsForEntityParams,
    GetRuleBanksParams,
    GetRuleColumnsParams,
    GetRuleListParams,
    GetRulesParams,
    ImportUploadResponse,
    JurisdictionResponse,
    LinkEntityRequest,
    ManualPoolAssignmentResponse,
    PaginatedAllUserResponse,
    PaginatedTenantResponse,
    PaginatedUserResponse,
    PolicyResponse,
    PolicyVersionResponse,
    PoolResponse,
    ProgressBarStatusResponse,
    ProjectListItemResponse,
    ProjectProgressBarStatusResponse,
    RemoveRuleBankParams,
    RoleResponse,
    RuleBankResponse,
    RuleColumnResponse,
    RuleListItemResponse,
    RuleResponse,
    SuperAdminGetAllTenantsParams,
    SuperAdminRestoreTenantParams,
    TenantResponse,
    TimePeriodResponse,
    ToggleOverridePoolsRequest,
    ToggleOverridePoolsResponse,
    TriggerFileCleanseParams,
    UpdatePoolRequest,
    UpdateProjectContractValueParams,
    UpdateProjectFinalValueParams,
    UpdateRuleRequest,
    UploadCleanseFileBody,
    UploadCleanseFileResponse,
    UploadImportFileBody,
    UserInfoResponse,
    UserPreferencesRequest,
    UserPreferencesResponse,
    UserResponse,
    UserTenantResponse,
} from './models';

import { useCustomAxios } from '../mutator/custom-instance';
import type { ErrorType } from '../mutator/custom-instance';

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenantHook = () => {
    const postV1ContactPersonAdminTenant =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createTenantContactRequest: CreateTenantContactRequest) => {
            return postV1ContactPersonAdminTenant({
                url: `/v1/ContactPerson/Admin/Tenant`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantContactRequest,
            });
        },
        [postV1ContactPersonAdminTenant]
    );
};

export const usePostV1ContactPersonAdminTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        TError,
        { data: CreateTenantContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const mutationKey = ['postV1ContactPersonAdminTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1ContactPersonAdminTenant =
        usePostV1ContactPersonAdminTenantHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        { data: CreateTenantContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonAdminTenant(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonAdminTenantMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >
>;
export type PostV1ContactPersonAdminTenantMutationBody =
    CreateTenantContactRequest;
export type PostV1ContactPersonAdminTenantMutationError = ErrorType<void>;

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        TError,
        { data: CreateTenantContactRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonAdminTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1ContactPersonAdminContactPersonIdHook = () => {
    const putV1ContactPersonAdminContactPersonId = useCustomAxios<void>();

    return useCallback(
        (
            contactPersonId: number,
            editContactPersonRequest: EditContactPersonRequest
        ) => {
            return putV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editContactPersonRequest,
            });
        },
        [putV1ContactPersonAdminContactPersonId]
    );
};

export const usePutV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        TError,
        { contactPersonId: number; data: EditContactPersonRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const mutationKey = ['putV1ContactPersonAdminContactPersonId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1ContactPersonAdminContactPersonId =
        usePutV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        { contactPersonId: number; data: EditContactPersonRequest }
    > = (props) => {
        const { contactPersonId, data } = props ?? {};

        return putV1ContactPersonAdminContactPersonId(contactPersonId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1ContactPersonAdminContactPersonIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >
>;
export type PutV1ContactPersonAdminContactPersonIdMutationBody =
    EditContactPersonRequest;
export type PutV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<void>;

export const usePutV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        TError,
        { contactPersonId: number; data: EditContactPersonRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteV1ContactPersonAdminContactPersonIdHook = () => {
    const deleteV1ContactPersonAdminContactPersonId = useCustomAxios<void>();

    return useCallback(
        (contactPersonId: number) => {
            return deleteV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'DELETE',
            });
        },
        [deleteV1ContactPersonAdminContactPersonId]
    );
};

export const useDeleteV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        TError,
        { contactPersonId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const mutationKey = ['deleteV1ContactPersonAdminContactPersonId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteV1ContactPersonAdminContactPersonId =
        useDeleteV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        { contactPersonId: number }
    > = (props) => {
        const { contactPersonId } = props ?? {};

        return deleteV1ContactPersonAdminContactPersonId(contactPersonId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1ContactPersonAdminContactPersonIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >
    >;

export type DeleteV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<void>;

export const useDeleteV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        TError,
        { contactPersonId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetAuditLogHook = () => {
    const getAuditLog = useCustomAxios<AuditLogResponse>();

    return useCallback(
        (params: GetAuditLogParams) => {
            return getAuditLog({ url: `/v1/Audit`, method: 'GET', params });
        },
        [getAuditLog]
    );
};

export const getGetAuditLogQueryKey = (params?: GetAuditLogParams) => {
    return [`/v1/Audit`, ...(params ? [params] : [])] as const;
};

export const useGetAuditLogQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>,
    TError = ErrorType<void>
>(
    params: GetAuditLogParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAuditLogQueryKey(params);

    const getAuditLog = useGetAuditLogHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>
    > = () => getAuditLog(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAuditLogQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>
>;
export type GetAuditLogQueryError = ErrorType<void>;

export function useGetAuditLog<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>,
    TError = ErrorType<void>
>(
    params: GetAuditLogParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAuditLogHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAuditLogQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useLogoutHook = () => {
    const logout = useCustomAxios<void>();

    return useCallback(() => {
        return logout({ url: `/v1/Auth/Logout`, method: 'POST' });
    }, [logout]);
};

export const useLogoutMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['logout'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const logout = useLogoutHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
        void
    > = () => {
        return logout();
    };

    return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>
>;

export type LogoutMutationError = ErrorType<void>;

export const useLogout = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions = useLogoutMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1ContactPersonTenantTenantIdHook = () => {
    const getV1ContactPersonTenantTenantId =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(
        (tenantId: number) => {
            return getV1ContactPersonTenantTenantId({
                url: `/v1/ContactPerson/Tenant/${tenantId}`,
                method: 'GET',
            });
        },
        [getV1ContactPersonTenantTenantId]
    );
};

export const getGetV1ContactPersonTenantTenantIdQueryKey = (
    tenantId?: number
) => {
    return [`/v1/ContactPerson/Tenant/${tenantId}`] as const;
};

export const useGetV1ContactPersonTenantTenantIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ContactPersonTenantTenantIdQueryKey(tenantId);

    const getV1ContactPersonTenantTenantId =
        useGetV1ContactPersonTenantTenantIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >
    > = () => getV1ContactPersonTenantTenantId(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ContactPersonTenantTenantIdQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >
>;
export type GetV1ContactPersonTenantTenantIdQueryError = ErrorType<void>;

export function useGetV1ContactPersonTenantTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1ContactPersonTenantTenantIdQueryOptions(
        tenantId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1ContactPersonApplicationHook = () => {
    const getV1ContactPersonApplication =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(() => {
        return getV1ContactPersonApplication({
            url: `/v1/ContactPerson/Application`,
            method: 'GET',
        });
    }, [getV1ContactPersonApplication]);
};

export const getGetV1ContactPersonApplicationQueryKey = () => {
    return [`/v1/ContactPerson/Application`] as const;
};

export const useGetV1ContactPersonApplicationQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1ContactPersonApplicationQueryKey();

    const getV1ContactPersonApplication =
        useGetV1ContactPersonApplicationHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >
    > = () => getV1ContactPersonApplication();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ContactPersonApplicationQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>>
>;
export type GetV1ContactPersonApplicationQueryError = ErrorType<unknown>;

export function useGetV1ContactPersonApplication<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1ContactPersonApplicationQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useUploadCleanseFileHook = () => {
    const uploadCleanseFile = useCustomAxios<UploadCleanseFileResponse>();

    return useCallback(
        (uploadCleanseFileBody: UploadCleanseFileBody) => {
            const formData = new FormData();
            if (uploadCleanseFileBody.EntityId !== undefined) {
                formData.append(
                    `EntityId`,
                    uploadCleanseFileBody.EntityId.toString()
                );
            }
            if (uploadCleanseFileBody.TimeId !== undefined) {
                formData.append(
                    `TimeId`,
                    uploadCleanseFileBody.TimeId.toString()
                );
            }
            if (uploadCleanseFileBody.DataType !== undefined) {
                formData.append(
                    `DataType`,
                    uploadCleanseFileBody.DataType.toString()
                );
            }
            formData.append(`File`, uploadCleanseFileBody.File);

            return uploadCleanseFile({
                url: `/v1/DataCleanse/uploads`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [uploadCleanseFile]
    );
};

export const useUploadCleanseFileMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>,
        TError,
        { data: UploadCleanseFileBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>,
    TError,
    { data: UploadCleanseFileBody },
    TContext
> => {
    const mutationKey = ['uploadCleanseFile'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const uploadCleanseFile = useUploadCleanseFileHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>,
        { data: UploadCleanseFileBody }
    > = (props) => {
        const { data } = props ?? {};

        return uploadCleanseFile(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UploadCleanseFileMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>
>;
export type UploadCleanseFileMutationBody = UploadCleanseFileBody;
export type UploadCleanseFileMutationError = ErrorType<void>;

export const useUploadCleanseFile = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>,
        TError,
        { data: UploadCleanseFileBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUploadCleanseFileHook>>>,
    TError,
    { data: UploadCleanseFileBody },
    TContext
> => {
    const mutationOptions = useUploadCleanseFileMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useTriggerFileCleanseHook = () => {
    const triggerFileCleanse = useCustomAxios<void>();

    return useCallback(
        (fileId: string, params?: TriggerFileCleanseParams) => {
            return triggerFileCleanse({
                url: `/v1/DataCleanse/files/${fileId}/trigger`,
                method: 'POST',
                params,
            });
        },
        [triggerFileCleanse]
    );
};

export const useTriggerFileCleanseMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>,
        TError,
        { fileId: string; params?: TriggerFileCleanseParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>,
    TError,
    { fileId: string; params?: TriggerFileCleanseParams },
    TContext
> => {
    const mutationKey = ['triggerFileCleanse'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const triggerFileCleanse = useTriggerFileCleanseHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>,
        { fileId: string; params?: TriggerFileCleanseParams }
    > = (props) => {
        const { fileId, params } = props ?? {};

        return triggerFileCleanse(fileId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type TriggerFileCleanseMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>
>;

export type TriggerFileCleanseMutationError = ErrorType<void>;

export const useTriggerFileCleanse = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>,
        TError,
        { fileId: string; params?: TriggerFileCleanseParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useTriggerFileCleanseHook>>>,
    TError,
    { fileId: string; params?: TriggerFileCleanseParams },
    TContext
> => {
    const mutationOptions = useTriggerFileCleanseMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetCleanseFilesHook = () => {
    const getCleanseFiles = useCustomAxios<CleanseFileResponse[]>();

    return useCallback(
        (params?: GetCleanseFilesParams) => {
            return getCleanseFiles({
                url: `/v1/DataCleanse/files`,
                method: 'GET',
                params,
            });
        },
        [getCleanseFiles]
    );
};

export const getGetCleanseFilesQueryKey = (params?: GetCleanseFilesParams) => {
    return [`/v1/DataCleanse/files`, ...(params ? [params] : [])] as const;
};

export const useGetCleanseFilesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetCleanseFilesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetCleanseFilesQueryKey(params);

    const getCleanseFiles = useGetCleanseFilesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>
    > = () => getCleanseFiles(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCleanseFilesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>
>;
export type GetCleanseFilesQueryError = ErrorType<void>;

export function useGetCleanseFiles<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetCleanseFilesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetCleanseFilesHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetCleanseFilesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetCleanseRunStatusHook = () => {
    const getCleanseRunStatus = useCustomAxios<DatabricksRunStatusResponse>();

    return useCallback(
        (runId: number) => {
            return getCleanseRunStatus({
                url: `/v1/DataCleanse/runs/${runId}`,
                method: 'GET',
            });
        },
        [getCleanseRunStatus]
    );
};

export const getGetCleanseRunStatusQueryKey = (runId?: number) => {
    return [`/v1/DataCleanse/runs/${runId}`] as const;
};

export const useGetCleanseRunStatusQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>,
    TError = ErrorType<void>
>(
    runId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetCleanseRunStatusQueryKey(runId);

    const getCleanseRunStatus = useGetCleanseRunStatusHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>
    > = () => getCleanseRunStatus(runId);

    return {
        queryKey,
        queryFn,
        enabled: !!runId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCleanseRunStatusQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>
>;
export type GetCleanseRunStatusQueryError = ErrorType<void>;

export function useGetCleanseRunStatus<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>,
    TError = ErrorType<void>
>(
    runId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetCleanseRunStatusHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetCleanseRunStatusQueryOptions(runId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateImportFromCleansedFileHook = () => {
    const createImportFromCleansedFile = useCustomAxios<ImportUploadResponse>();

    return useCallback(
        (fileId: string, params?: CreateImportFromCleansedFileParams) => {
            return createImportFromCleansedFile({
                url: `/v1/DataCleanse/files/${fileId}/import-source`,
                method: 'POST',
                params,
            });
        },
        [createImportFromCleansedFile]
    );
};

export const useCreateImportFromCleansedFileMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>
        >,
        TError,
        { fileId: string; params?: CreateImportFromCleansedFileParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>>,
    TError,
    { fileId: string; params?: CreateImportFromCleansedFileParams },
    TContext
> => {
    const mutationKey = ['createImportFromCleansedFile'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createImportFromCleansedFile = useCreateImportFromCleansedFileHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>
        >,
        { fileId: string; params?: CreateImportFromCleansedFileParams }
    > = (props) => {
        const { fileId, params } = props ?? {};

        return createImportFromCleansedFile(fileId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateImportFromCleansedFileMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>>
>;

export type CreateImportFromCleansedFileMutationError = ErrorType<void>;

export const useCreateImportFromCleansedFile = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>
        >,
        TError,
        { fileId: string; params?: CreateImportFromCleansedFileParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateImportFromCleansedFileHook>>>,
    TError,
    { fileId: string; params?: CreateImportFromCleansedFileParams },
    TContext
> => {
    const mutationOptions =
        useCreateImportFromCleansedFileMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useRefreshPendingCleanseJobsHook = () => {
    const refreshPendingCleanseJobs = useCustomAxios<void>();

    return useCallback(() => {
        return refreshPendingCleanseJobs({
            url: `/v1/DataCleanse/refresh`,
            method: 'POST',
        });
    }, [refreshPendingCleanseJobs]);
};

export const useRefreshPendingCleanseJobsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>
        >,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['refreshPendingCleanseJobs'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const refreshPendingCleanseJobs = useRefreshPendingCleanseJobsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>
        >,
        void
    > = () => {
        return refreshPendingCleanseJobs();
    };

    return { mutationFn, ...mutationOptions };
};

export type RefreshPendingCleanseJobsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>>
>;

export type RefreshPendingCleanseJobsMutationError = ErrorType<void>;

export const useRefreshPendingCleanseJobs = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>
        >,
        TError,
        void,
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRefreshPendingCleanseJobsHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions =
        useRefreshPendingCleanseJobsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetDataGridHook = () => {
    const getDataGrid = useCustomAxios<DataGridResponse>();

    return useCallback(
        (params?: GetDataGridParams) => {
            return getDataGrid({
                url: `/v1/Datasets/grid`,
                method: 'GET',
                params,
            });
        },
        [getDataGrid]
    );
};

export const getGetDataGridQueryKey = (params?: GetDataGridParams) => {
    return [`/v1/Datasets/grid`, ...(params ? [params] : [])] as const;
};

export const useGetDataGridQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>,
    TError = ErrorType<void>
>(
    params?: GetDataGridParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetDataGridQueryKey(params);

    const getDataGrid = useGetDataGridHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>
    > = () => getDataGrid(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetDataGridQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>
>;
export type GetDataGridQueryError = ErrorType<void>;

export function useGetDataGrid<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>,
    TError = ErrorType<void>
>(
    params?: GetDataGridParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetDataGridHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetDataGridQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetDatasetColumnsHook = () => {
    const getDatasetColumns = useCustomAxios<DataColumnResponse[]>();

    return useCallback(
        (params?: GetDatasetColumnsParams) => {
            return getDatasetColumns({
                url: `/v1/Datasets/columns`,
                method: 'GET',
                params,
            });
        },
        [getDatasetColumns]
    );
};

export const getGetDatasetColumnsQueryKey = (
    params?: GetDatasetColumnsParams
) => {
    return [`/v1/Datasets/columns`, ...(params ? [params] : [])] as const;
};

export const useGetDatasetColumnsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetDatasetColumnsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetDatasetColumnsQueryKey(params);

    const getDatasetColumns = useGetDatasetColumnsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>
    > = () => getDatasetColumns(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetDatasetColumnsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>
>;
export type GetDatasetColumnsQueryError = ErrorType<void>;

export function useGetDatasetColumns<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetDatasetColumnsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetDatasetColumnsHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetDatasetColumnsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateDatasetColumnsHook = () => {
    const createDatasetColumns = useCustomAxios<DataColumnResponse[]>();

    return useCallback(
        (
            createColumnsRequest: CreateColumnsRequest,
            params?: CreateDatasetColumnsParams
        ) => {
            return createDatasetColumns({
                url: `/v1/Datasets/columns`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createColumnsRequest,
                params,
            });
        },
        [createDatasetColumns]
    );
};

export const useCreateDatasetColumnsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>,
        TError,
        { data: CreateColumnsRequest; params?: CreateDatasetColumnsParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>,
    TError,
    { data: CreateColumnsRequest; params?: CreateDatasetColumnsParams },
    TContext
> => {
    const mutationKey = ['createDatasetColumns'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createDatasetColumns = useCreateDatasetColumnsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>,
        { data: CreateColumnsRequest; params?: CreateDatasetColumnsParams }
    > = (props) => {
        const { data, params } = props ?? {};

        return createDatasetColumns(data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateDatasetColumnsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>
>;
export type CreateDatasetColumnsMutationBody = CreateColumnsRequest;
export type CreateDatasetColumnsMutationError = ErrorType<void>;

export const useCreateDatasetColumns = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>,
        TError,
        { data: CreateColumnsRequest; params?: CreateDatasetColumnsParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateDatasetColumnsHook>>>,
    TError,
    { data: CreateColumnsRequest; params?: CreateDatasetColumnsParams },
    TContext
> => {
    const mutationOptions = useCreateDatasetColumnsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetDataFieldDefinitionsHook = () => {
    const getDataFieldDefinitions =
        useCustomAxios<DataFieldDefinitionResponse[]>();

    return useCallback(
        (params?: GetDataFieldDefinitionsParams) => {
            return getDataFieldDefinitions({
                url: `/v1/Datasets/field-definitions`,
                method: 'GET',
                params,
            });
        },
        [getDataFieldDefinitions]
    );
};

export const getGetDataFieldDefinitionsQueryKey = (
    params?: GetDataFieldDefinitionsParams
) => {
    return [
        `/v1/Datasets/field-definitions`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetDataFieldDefinitionsQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetDataFieldDefinitionsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetDataFieldDefinitionsQueryKey(params);

    const getDataFieldDefinitions = useGetDataFieldDefinitionsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>>
    > = () => getDataFieldDefinitions(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetDataFieldDefinitionsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>>
>;
export type GetDataFieldDefinitionsQueryError = ErrorType<void>;

export function useGetDataFieldDefinitions<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetDataFieldDefinitionsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetDataFieldDefinitionsHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetDataFieldDefinitionsQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetEntitiesForTimePeriodHook = () => {
    const getEntitiesForTimePeriod = useCustomAxios<EntityResponse[]>();

    return useCallback(
        (timeId: number) => {
            return getEntitiesForTimePeriod({
                url: `/v1/Entity/${timeId}`,
                method: 'GET',
            });
        },
        [getEntitiesForTimePeriod]
    );
};

export const getGetEntitiesForTimePeriodQueryKey = (timeId?: number) => {
    return [`/v1/Entity/${timeId}`] as const;
};

export const useGetEntitiesForTimePeriodQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>
    >,
    TError = ErrorType<void>
>(
    timeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetEntitiesForTimePeriodQueryKey(timeId);

    const getEntitiesForTimePeriod = useGetEntitiesForTimePeriodHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>>
    > = () => getEntitiesForTimePeriod(timeId);

    return {
        queryKey,
        queryFn,
        enabled: !!timeId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetEntitiesForTimePeriodQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>>
>;
export type GetEntitiesForTimePeriodQueryError = ErrorType<void>;

export function useGetEntitiesForTimePeriod<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>
    >,
    TError = ErrorType<void>
>(
    timeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetEntitiesForTimePeriodHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetEntitiesForTimePeriodQueryOptions(
        timeId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetJurisdictionsHook = () => {
    const getJurisdictions = useCustomAxios<JurisdictionResponse[]>();

    return useCallback(() => {
        return getJurisdictions({
            url: `/v1/Entity/jurisdictions`,
            method: 'GET',
        });
    }, [getJurisdictions]);
};

export const getGetJurisdictionsQueryKey = () => {
    return [`/v1/Entity/jurisdictions`] as const;
};

export const useGetJurisdictionsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetJurisdictionsQueryKey();

    const getJurisdictions = useGetJurisdictionsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>
    > = () => getJurisdictions();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetJurisdictionsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>
>;
export type GetJurisdictionsQueryError = ErrorType<unknown>;

export function useGetJurisdictions<
    TData = Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetJurisdictionsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetJurisdictionsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateEntityHook = () => {
    const createEntity = useCustomAxios<EntityResponse>();

    return useCallback(
        (createEntityRequest: CreateEntityRequest) => {
            return createEntity({
                url: `/v1/Entity`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createEntityRequest,
            });
        },
        [createEntity]
    );
};

export const useCreateEntityMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>,
        TError,
        { data: CreateEntityRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>,
    TError,
    { data: CreateEntityRequest },
    TContext
> => {
    const mutationKey = ['createEntity'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createEntity = useCreateEntityHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>,
        { data: CreateEntityRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createEntity(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateEntityMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>
>;
export type CreateEntityMutationBody = CreateEntityRequest;
export type CreateEntityMutationError = ErrorType<void>;

export const useCreateEntity = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>,
        TError,
        { data: CreateEntityRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateEntityHook>>>,
    TError,
    { data: CreateEntityRequest },
    TContext
> => {
    const mutationOptions = useCreateEntityMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useLinkEntityToTimePeriodHook = () => {
    const linkEntityToTimePeriod = useCustomAxios<EntityResponse>();

    return useCallback(
        (linkEntityRequest: LinkEntityRequest) => {
            return linkEntityToTimePeriod({
                url: `/v1/Entity/link`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: linkEntityRequest,
            });
        },
        [linkEntityToTimePeriod]
    );
};

export const useLinkEntityToTimePeriodMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>,
        TError,
        { data: LinkEntityRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>,
    TError,
    { data: LinkEntityRequest },
    TContext
> => {
    const mutationKey = ['linkEntityToTimePeriod'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const linkEntityToTimePeriod = useLinkEntityToTimePeriodHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>,
        { data: LinkEntityRequest }
    > = (props) => {
        const { data } = props ?? {};

        return linkEntityToTimePeriod(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type LinkEntityToTimePeriodMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>
>;
export type LinkEntityToTimePeriodMutationBody = LinkEntityRequest;
export type LinkEntityToTimePeriodMutationError = ErrorType<void>;

export const useLinkEntityToTimePeriod = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>,
        TError,
        { data: LinkEntityRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useLinkEntityToTimePeriodHook>>>,
    TError,
    { data: LinkEntityRequest },
    TContext
> => {
    const mutationOptions = useLinkEntityToTimePeriodMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetEntitiesNotLinkedToTimePeriodHook = () => {
    const getEntitiesNotLinkedToTimePeriod =
        useCustomAxios<EntitiesUnlinkedResponse[]>();

    return useCallback(
        (timeId: number) => {
            return getEntitiesNotLinkedToTimePeriod({
                url: `/v1/Entity/unlinked/${timeId}`,
                method: 'GET',
            });
        },
        [getEntitiesNotLinkedToTimePeriod]
    );
};

export const getGetEntitiesNotLinkedToTimePeriodQueryKey = (
    timeId?: number
) => {
    return [`/v1/Entity/unlinked/${timeId}`] as const;
};

export const useGetEntitiesNotLinkedToTimePeriodQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>>
    >,
    TError = ErrorType<void>
>(
    timeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetEntitiesNotLinkedToTimePeriodQueryKey(timeId);

    const getEntitiesNotLinkedToTimePeriod =
        useGetEntitiesNotLinkedToTimePeriodHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>
            >
        >
    > = () => getEntitiesNotLinkedToTimePeriod(timeId);

    return {
        queryKey,
        queryFn,
        enabled: !!timeId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetEntitiesNotLinkedToTimePeriodQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>>
    >
>;
export type GetEntitiesNotLinkedToTimePeriodQueryError = ErrorType<void>;

export function useGetEntitiesNotLinkedToTimePeriod<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>>
    >,
    TError = ErrorType<void>
>(
    timeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetEntitiesNotLinkedToTimePeriodHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetEntitiesNotLinkedToTimePeriodQueryOptions(
        timeId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useDeleteEntityHook = () => {
    const deleteEntity = useCustomAxios<void>();

    return useCallback(
        (entityId: number) => {
            return deleteEntity({
                url: `/v1/Entity/${entityId}`,
                method: 'DELETE',
            });
        },
        [deleteEntity]
    );
};

export const useDeleteEntityMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>,
        TError,
        { entityId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>,
    TError,
    { entityId: number },
    TContext
> => {
    const mutationKey = ['deleteEntity'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteEntity = useDeleteEntityHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>,
        { entityId: number }
    > = (props) => {
        const { entityId } = props ?? {};

        return deleteEntity(entityId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteEntityMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>
>;

export type DeleteEntityMutationError = ErrorType<void>;

export const useDeleteEntity = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>,
        TError,
        { entityId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteEntityHook>>>,
    TError,
    { entityId: number },
    TContext
> => {
    const mutationOptions = useDeleteEntityMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useToggleOverridePoolsHook = () => {
    const toggleOverridePools = useCustomAxios<ToggleOverridePoolsResponse>();

    return useCallback(
        (
            entityId: number,
            toggleOverridePoolsRequest: ToggleOverridePoolsRequest
        ) => {
            return toggleOverridePools({
                url: `/v1/Entity/${entityId}/override-pools`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: toggleOverridePoolsRequest,
            });
        },
        [toggleOverridePools]
    );
};

export const useToggleOverridePoolsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>,
        TError,
        { entityId: number; data: ToggleOverridePoolsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>,
    TError,
    { entityId: number; data: ToggleOverridePoolsRequest },
    TContext
> => {
    const mutationKey = ['toggleOverridePools'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const toggleOverridePools = useToggleOverridePoolsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>,
        { entityId: number; data: ToggleOverridePoolsRequest }
    > = (props) => {
        const { entityId, data } = props ?? {};

        return toggleOverridePools(entityId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ToggleOverridePoolsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>
>;
export type ToggleOverridePoolsMutationBody = ToggleOverridePoolsRequest;
export type ToggleOverridePoolsMutationError = ErrorType<void>;

export const useToggleOverridePools = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>,
        TError,
        { entityId: number; data: ToggleOverridePoolsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useToggleOverridePoolsHook>>>,
    TError,
    { entityId: number; data: ToggleOverridePoolsRequest },
    TContext
> => {
    const mutationOptions = useToggleOverridePoolsMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns the authenticated user's profile, role, and available tenants
 */
export const useGetUserInfoHook = () => {
    const getUserInfo = useCustomAxios<UserInfoResponse>();

    return useCallback(() => {
        return getUserInfo({ url: `/v1/Identity/UserInfo`, method: 'GET' });
    }, [getUserInfo]);
};

export const getGetUserInfoQueryKey = () => {
    return [`/v1/Identity/UserInfo`] as const;
};

export const useGetUserInfoQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserInfoQueryKey();

    const getUserInfo = useGetUserInfoHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>
    > = () => getUserInfo();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserInfoQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>
>;
export type GetUserInfoQueryError = ErrorType<void>;

/**
 * @summary Returns the authenticated user's profile, role, and available tenants
 */

export function useGetUserInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserInfoHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUserInfoQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useUploadImportFileHook = () => {
    const uploadImportFile = useCustomAxios<ImportUploadResponse>();

    return useCallback(
        (uploadImportFileBody: UploadImportFileBody) => {
            const formData = new FormData();
            if (uploadImportFileBody.EntityId !== undefined) {
                formData.append(
                    `EntityId`,
                    uploadImportFileBody.EntityId.toString()
                );
            }
            if (uploadImportFileBody.TimeId !== undefined) {
                formData.append(
                    `TimeId`,
                    uploadImportFileBody.TimeId.toString()
                );
            }
            formData.append(`File`, uploadImportFileBody.File);

            return uploadImportFile({
                url: `/v1/Imports/uploads`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [uploadImportFile]
    );
};

export const useUploadImportFileMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>,
        TError,
        { data: UploadImportFileBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>,
    TError,
    { data: UploadImportFileBody },
    TContext
> => {
    const mutationKey = ['uploadImportFile'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const uploadImportFile = useUploadImportFileHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>,
        { data: UploadImportFileBody }
    > = (props) => {
        const { data } = props ?? {};

        return uploadImportFile(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UploadImportFileMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>
>;
export type UploadImportFileMutationBody = UploadImportFileBody;
export type UploadImportFileMutationError = ErrorType<void>;

export const useUploadImportFile = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>,
        TError,
        { data: UploadImportFileBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUploadImportFileHook>>>,
    TError,
    { data: UploadImportFileBody },
    TContext
> => {
    const mutationOptions = useUploadImportFileMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useCommitFixedAssetImportHook = () => {
    const commitFixedAssetImport = useCustomAxios<CommitImportResponse>();

    return useCallback(
        (commitImportRequest: CommitImportRequest) => {
            return commitFixedAssetImport({
                url: `/v1/Imports/commit`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: commitImportRequest,
            });
        },
        [commitFixedAssetImport]
    );
};

export const useCommitFixedAssetImportMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>,
        TError,
        { data: CommitImportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>,
    TError,
    { data: CommitImportRequest },
    TContext
> => {
    const mutationKey = ['commitFixedAssetImport'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const commitFixedAssetImport = useCommitFixedAssetImportHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>,
        { data: CommitImportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return commitFixedAssetImport(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CommitFixedAssetImportMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>
>;
export type CommitFixedAssetImportMutationBody = CommitImportRequest;
export type CommitFixedAssetImportMutationError = ErrorType<void>;

export const useCommitFixedAssetImport = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>,
        TError,
        { data: CommitImportRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCommitFixedAssetImportHook>>>,
    TError,
    { data: CommitImportRequest },
    TContext
> => {
    const mutationOptions = useCommitFixedAssetImportMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useCommitProjectDataImportHook = () => {
    const commitProjectDataImport =
        useCustomAxios<CommitProjectDataImportResponse>();

    return useCallback(
        (commitProjectDataImportRequest: CommitProjectDataImportRequest) => {
            return commitProjectDataImport({
                url: `/v1/Imports/project-data/commit`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: commitProjectDataImportRequest,
            });
        },
        [commitProjectDataImport]
    );
};

export const useCommitProjectDataImportMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>,
        TError,
        { data: CommitProjectDataImportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>,
    TError,
    { data: CommitProjectDataImportRequest },
    TContext
> => {
    const mutationKey = ['commitProjectDataImport'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const commitProjectDataImport = useCommitProjectDataImportHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>,
        { data: CommitProjectDataImportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return commitProjectDataImport(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CommitProjectDataImportMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>
>;
export type CommitProjectDataImportMutationBody =
    CommitProjectDataImportRequest;
export type CommitProjectDataImportMutationError = ErrorType<void>;

export const useCommitProjectDataImport = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>,
        TError,
        { data: CommitProjectDataImportRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCommitProjectDataImportHook>>>,
    TError,
    { data: CommitProjectDataImportRequest },
    TContext
> => {
    const mutationOptions = useCommitProjectDataImportMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useCommitRuleImportHook = () => {
    const commitRuleImport = useCustomAxios<CommitRuleImportResponse>();

    return useCallback(
        (commitRuleImportRequest: CommitRuleImportRequest) => {
            return commitRuleImport({
                url: `/v1/Imports/rules/commit`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: commitRuleImportRequest,
            });
        },
        [commitRuleImport]
    );
};

export const useCommitRuleImportMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>,
        TError,
        { data: CommitRuleImportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>,
    TError,
    { data: CommitRuleImportRequest },
    TContext
> => {
    const mutationKey = ['commitRuleImport'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const commitRuleImport = useCommitRuleImportHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>,
        { data: CommitRuleImportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return commitRuleImport(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CommitRuleImportMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>
>;
export type CommitRuleImportMutationBody = CommitRuleImportRequest;
export type CommitRuleImportMutationError = ErrorType<void>;

export const useCommitRuleImport = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>,
        TError,
        { data: CommitRuleImportRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCommitRuleImportHook>>>,
    TError,
    { data: CommitRuleImportRequest },
    TContext
> => {
    const mutationOptions = useCommitRuleImportMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1PolicyPrivacyHook = () => {
    const getV1PolicyPrivacy = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyPrivacy({ url: `/v1/Policy/Privacy`, method: 'GET' });
    }, [getV1PolicyPrivacy]);
};

export const getGetV1PolicyPrivacyQueryKey = () => {
    return [`/v1/Policy/Privacy`] as const;
};

export const useGetV1PolicyPrivacyQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyPrivacyQueryKey();

    const getV1PolicyPrivacy = useGetV1PolicyPrivacyHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
    > = () => getV1PolicyPrivacy();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyPrivacyQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
>;
export type GetV1PolicyPrivacyQueryError = ErrorType<void>;

export function useGetV1PolicyPrivacy<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1PolicyPrivacyQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyCookiesHook = () => {
    const getV1PolicyCookies = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyCookies({ url: `/v1/Policy/Cookies`, method: 'GET' });
    }, [getV1PolicyCookies]);
};

export const getGetV1PolicyCookiesQueryKey = () => {
    return [`/v1/Policy/Cookies`] as const;
};

export const useGetV1PolicyCookiesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyCookiesQueryKey();

    const getV1PolicyCookies = useGetV1PolicyCookiesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
    > = () => getV1PolicyCookies();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyCookiesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
>;
export type GetV1PolicyCookiesQueryError = ErrorType<void>;

export function useGetV1PolicyCookies<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1PolicyCookiesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyTermsHook = () => {
    const getV1PolicyTerms = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyTerms({ url: `/v1/Policy/Terms`, method: 'GET' });
    }, [getV1PolicyTerms]);
};

export const getGetV1PolicyTermsQueryKey = () => {
    return [`/v1/Policy/Terms`] as const;
};

export const useGetV1PolicyTermsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyTermsQueryKey();

    const getV1PolicyTerms = useGetV1PolicyTermsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
    > = () => getV1PolicyTerms();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyTermsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
>;
export type GetV1PolicyTermsQueryError = ErrorType<void>;

export function useGetV1PolicyTerms<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1PolicyTermsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyTermsVersionHook = () => {
    const getV1PolicyTermsVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyTermsVersion({
            url: `/v1/Policy/terms/version`,
            method: 'GET',
        });
    }, [getV1PolicyTermsVersion]);
};

export const getGetV1PolicyTermsVersionQueryKey = () => {
    return [`/v1/Policy/terms/version`] as const;
};

export const useGetV1PolicyTermsVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyTermsVersionQueryKey();

    const getV1PolicyTermsVersion = useGetV1PolicyTermsVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
    > = () => getV1PolicyTermsVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyTermsVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
>;
export type GetV1PolicyTermsVersionQueryError = ErrorType<void>;

export function useGetV1PolicyTermsVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1PolicyTermsVersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyCookiesVersionHook = () => {
    const getV1PolicyCookiesVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyCookiesVersion({
            url: `/v1/Policy/cookies/version`,
            method: 'GET',
        });
    }, [getV1PolicyCookiesVersion]);
};

export const getGetV1PolicyCookiesVersionQueryKey = () => {
    return [`/v1/Policy/cookies/version`] as const;
};

export const useGetV1PolicyCookiesVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyCookiesVersionQueryKey();

    const getV1PolicyCookiesVersion = useGetV1PolicyCookiesVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
    > = () => getV1PolicyCookiesVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyCookiesVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
>;
export type GetV1PolicyCookiesVersionQueryError = ErrorType<void>;

export function useGetV1PolicyCookiesVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetV1PolicyCookiesVersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useApplyManualFixedAssetPoolSplitsHook = () => {
    const applyManualFixedAssetPoolSplits =
        useCustomAxios<ManualPoolAssignmentResponse>();

    return useCallback(
        (
            applyManualFixedAssetSplitsRequest: ApplyManualFixedAssetSplitsRequest
        ) => {
            return applyManualFixedAssetPoolSplits({
                url: `/v1/PoolAssignments/fa-manual-splits`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: applyManualFixedAssetSplitsRequest,
            });
        },
        [applyManualFixedAssetPoolSplits]
    );
};

export const useApplyManualFixedAssetPoolSplitsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>
            >
        >,
        TError,
        { data: ApplyManualFixedAssetSplitsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>>
    >,
    TError,
    { data: ApplyManualFixedAssetSplitsRequest },
    TContext
> => {
    const mutationKey = ['applyManualFixedAssetPoolSplits'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const applyManualFixedAssetPoolSplits =
        useApplyManualFixedAssetPoolSplitsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>
            >
        >,
        { data: ApplyManualFixedAssetSplitsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return applyManualFixedAssetPoolSplits(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ApplyManualFixedAssetPoolSplitsMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>>
    >
>;
export type ApplyManualFixedAssetPoolSplitsMutationBody =
    ApplyManualFixedAssetSplitsRequest;
export type ApplyManualFixedAssetPoolSplitsMutationError = ErrorType<void>;

export const useApplyManualFixedAssetPoolSplits = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>
            >
        >,
        TError,
        { data: ApplyManualFixedAssetSplitsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useApplyManualFixedAssetPoolSplitsHook>>
    >,
    TError,
    { data: ApplyManualFixedAssetSplitsRequest },
    TContext
> => {
    const mutationOptions =
        useApplyManualFixedAssetPoolSplitsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useApplyManualFixedAssetRuleHook = () => {
    const applyManualFixedAssetRule =
        useCustomAxios<ManualPoolAssignmentResponse>();

    return useCallback(
        (
            applyManualFixedAssetRuleRequest: ApplyManualFixedAssetRuleRequest
        ) => {
            return applyManualFixedAssetRule({
                url: `/v1/PoolAssignments/fa-manual-rule`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: applyManualFixedAssetRuleRequest,
            });
        },
        [applyManualFixedAssetRule]
    );
};

export const useApplyManualFixedAssetRuleMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>
        >,
        TError,
        { data: ApplyManualFixedAssetRuleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>>,
    TError,
    { data: ApplyManualFixedAssetRuleRequest },
    TContext
> => {
    const mutationKey = ['applyManualFixedAssetRule'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const applyManualFixedAssetRule = useApplyManualFixedAssetRuleHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>
        >,
        { data: ApplyManualFixedAssetRuleRequest }
    > = (props) => {
        const { data } = props ?? {};

        return applyManualFixedAssetRule(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ApplyManualFixedAssetRuleMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>>
>;
export type ApplyManualFixedAssetRuleMutationBody =
    ApplyManualFixedAssetRuleRequest;
export type ApplyManualFixedAssetRuleMutationError = ErrorType<void>;

export const useApplyManualFixedAssetRule = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>
        >,
        TError,
        { data: ApplyManualFixedAssetRuleRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useApplyManualFixedAssetRuleHook>>>,
    TError,
    { data: ApplyManualFixedAssetRuleRequest },
    TContext
> => {
    const mutationOptions =
        useApplyManualFixedAssetRuleMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useApplyManualProjectPoolSplitsHook = () => {
    const applyManualProjectPoolSplits =
        useCustomAxios<ManualPoolAssignmentResponse>();

    return useCallback(
        (applyManualProjectSplitsRequest: ApplyManualProjectSplitsRequest) => {
            return applyManualProjectPoolSplits({
                url: `/v1/PoolAssignments/project-manual-splits`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: applyManualProjectSplitsRequest,
            });
        },
        [applyManualProjectPoolSplits]
    );
};

export const useApplyManualProjectPoolSplitsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>
        >,
        TError,
        { data: ApplyManualProjectSplitsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>>,
    TError,
    { data: ApplyManualProjectSplitsRequest },
    TContext
> => {
    const mutationKey = ['applyManualProjectPoolSplits'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const applyManualProjectPoolSplits = useApplyManualProjectPoolSplitsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>
        >,
        { data: ApplyManualProjectSplitsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return applyManualProjectPoolSplits(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ApplyManualProjectPoolSplitsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>>
>;
export type ApplyManualProjectPoolSplitsMutationBody =
    ApplyManualProjectSplitsRequest;
export type ApplyManualProjectPoolSplitsMutationError = ErrorType<void>;

export const useApplyManualProjectPoolSplits = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>
        >,
        TError,
        { data: ApplyManualProjectSplitsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useApplyManualProjectPoolSplitsHook>>>,
    TError,
    { data: ApplyManualProjectSplitsRequest },
    TContext
> => {
    const mutationOptions =
        useApplyManualProjectPoolSplitsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetPoolsHook = () => {
    const getPools = useCustomAxios<PoolResponse[]>();

    return useCallback(
        (params?: GetPoolsParams) => {
            return getPools({ url: `/v1/Pools`, method: 'GET', params });
        },
        [getPools]
    );
};

export const getGetPoolsQueryKey = (params?: GetPoolsParams) => {
    return [`/v1/Pools`, ...(params ? [params] : [])] as const;
};

export const useGetPoolsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetPoolsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPoolsQueryKey(params);

    const getPools = useGetPoolsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>
    > = () => getPools(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetPoolsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>
>;
export type GetPoolsQueryError = ErrorType<void>;

export function useGetPools<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetPoolsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetPoolsHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetPoolsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreatePoolHook = () => {
    const createPool = useCustomAxios<PoolResponse>();

    return useCallback(
        (createPoolRequest: CreatePoolRequest) => {
            return createPool({
                url: `/v1/Pools`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createPoolRequest,
            });
        },
        [createPool]
    );
};

export const useCreatePoolMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>,
        TError,
        { data: CreatePoolRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>,
    TError,
    { data: CreatePoolRequest },
    TContext
> => {
    const mutationKey = ['createPool'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createPool = useCreatePoolHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>,
        { data: CreatePoolRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createPool(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreatePoolMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>
>;
export type CreatePoolMutationBody = CreatePoolRequest;
export type CreatePoolMutationError = ErrorType<void>;

export const useCreatePool = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>,
        TError,
        { data: CreatePoolRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreatePoolHook>>>,
    TError,
    { data: CreatePoolRequest },
    TContext
> => {
    const mutationOptions = useCreatePoolMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetPoolByIdHook = () => {
    const getPoolById = useCustomAxios<PoolResponse>();

    return useCallback(
        (poolId: number) => {
            return getPoolById({ url: `/v1/Pools/${poolId}`, method: 'GET' });
        },
        [getPoolById]
    );
};

export const getGetPoolByIdQueryKey = (poolId?: number) => {
    return [`/v1/Pools/${poolId}`] as const;
};

export const useGetPoolByIdQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>,
    TError = ErrorType<void>
>(
    poolId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPoolByIdQueryKey(poolId);

    const getPoolById = useGetPoolByIdHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>
    > = () => getPoolById(poolId);

    return {
        queryKey,
        queryFn,
        enabled: !!poolId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetPoolByIdQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>
>;
export type GetPoolByIdQueryError = ErrorType<void>;

export function useGetPoolById<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>,
    TError = ErrorType<void>
>(
    poolId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetPoolByIdHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetPoolByIdQueryOptions(poolId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useUpdatePoolHook = () => {
    const updatePool = useCustomAxios<PoolResponse>();

    return useCallback(
        (poolId: number, updatePoolRequest: UpdatePoolRequest) => {
            return updatePool({
                url: `/v1/Pools/${poolId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: updatePoolRequest,
            });
        },
        [updatePool]
    );
};

export const useUpdatePoolMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>,
        TError,
        { poolId: number; data: UpdatePoolRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>,
    TError,
    { poolId: number; data: UpdatePoolRequest },
    TContext
> => {
    const mutationKey = ['updatePool'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updatePool = useUpdatePoolHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>,
        { poolId: number; data: UpdatePoolRequest }
    > = (props) => {
        const { poolId, data } = props ?? {};

        return updatePool(poolId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdatePoolMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>
>;
export type UpdatePoolMutationBody = UpdatePoolRequest;
export type UpdatePoolMutationError = ErrorType<void>;

export const useUpdatePool = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>,
        TError,
        { poolId: number; data: UpdatePoolRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdatePoolHook>>>,
    TError,
    { poolId: number; data: UpdatePoolRequest },
    TContext
> => {
    const mutationOptions = useUpdatePoolMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeletePoolHook = () => {
    const deletePool = useCustomAxios<void>();

    return useCallback(
        (poolId: number, params?: DeletePoolParams) => {
            return deletePool({
                url: `/v1/Pools/${poolId}`,
                method: 'DELETE',
                params,
            });
        },
        [deletePool]
    );
};

export const useDeletePoolMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>,
        TError,
        { poolId: number; params?: DeletePoolParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>,
    TError,
    { poolId: number; params?: DeletePoolParams },
    TContext
> => {
    const mutationKey = ['deletePool'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deletePool = useDeletePoolHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>,
        { poolId: number; params?: DeletePoolParams }
    > = (props) => {
        const { poolId, params } = props ?? {};

        return deletePool(poolId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeletePoolMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>
>;

export type DeletePoolMutationError = ErrorType<void>;

export const useDeletePool = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>,
        TError,
        { poolId: number; params?: DeletePoolParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeletePoolHook>>>,
    TError,
    { poolId: number; params?: DeletePoolParams },
    TContext
> => {
    const mutationOptions = useDeletePoolMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetDefaultPoolShortNamesHook = () => {
    const getDefaultPoolShortNames = useCustomAxios<string[]>();

    return useCallback(() => {
        return getDefaultPoolShortNames({
            url: `/v1/Pools/defaults/short-names`,
            method: 'GET',
        });
    }, [getDefaultPoolShortNames]);
};

export const getGetDefaultPoolShortNamesQueryKey = () => {
    return [`/v1/Pools/defaults/short-names`] as const;
};

export const useGetDefaultPoolShortNamesQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetDefaultPoolShortNamesQueryKey();

    const getDefaultPoolShortNames = useGetDefaultPoolShortNamesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>>
    > = () => getDefaultPoolShortNames();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetDefaultPoolShortNamesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>>
>;
export type GetDefaultPoolShortNamesQueryError = ErrorType<unknown>;

export function useGetDefaultPoolShortNames<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDefaultPoolShortNamesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetDefaultPoolShortNamesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetAccountingMethodsHook = () => {
    const getAccountingMethods = useCustomAxios<AccountingMethodResponse[]>();

    return useCallback(() => {
        return getAccountingMethods({
            url: `/v1/Pools/accounting-methods`,
            method: 'GET',
        });
    }, [getAccountingMethods]);
};

export const getGetAccountingMethodsQueryKey = () => {
    return [`/v1/Pools/accounting-methods`] as const;
};

export const useGetAccountingMethodsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetAccountingMethodsQueryKey();

    const getAccountingMethods = useGetAccountingMethodsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>
    > = () => getAccountingMethods();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAccountingMethodsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>
>;
export type GetAccountingMethodsQueryError = ErrorType<unknown>;

export function useGetAccountingMethods<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAccountingMethodsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAccountingMethodsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetFAProgressBarStatusHook = () => {
    const getFAProgressBarStatus = useCustomAxios<ProgressBarStatusResponse>();

    return useCallback(
        (params?: GetFAProgressBarStatusParams) => {
            return getFAProgressBarStatus({
                url: `/v1/ProgressBar/fa`,
                method: 'GET',
                params,
            });
        },
        [getFAProgressBarStatus]
    );
};

export const getGetFAProgressBarStatusQueryKey = (
    params?: GetFAProgressBarStatusParams
) => {
    return [`/v1/ProgressBar/fa`, ...(params ? [params] : [])] as const;
};

export const useGetFAProgressBarStatusQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetFAProgressBarStatusParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetFAProgressBarStatusQueryKey(params);

    const getFAProgressBarStatus = useGetFAProgressBarStatusHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>>
    > = () => getFAProgressBarStatus(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetFAProgressBarStatusQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>>
>;
export type GetFAProgressBarStatusQueryError = ErrorType<void>;

export function useGetFAProgressBarStatus<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetFAProgressBarStatusParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetFAProgressBarStatusHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetFAProgressBarStatusQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetProjectProgressBarStatusHook = () => {
    const getProjectProgressBarStatus =
        useCustomAxios<ProjectProgressBarStatusResponse>();

    return useCallback(
        (params?: GetProjectProgressBarStatusParams) => {
            return getProjectProgressBarStatus({
                url: `/v1/ProgressBar/project`,
                method: 'GET',
                params,
            });
        },
        [getProjectProgressBarStatus]
    );
};

export const getGetProjectProgressBarStatusQueryKey = (
    params?: GetProjectProgressBarStatusParams
) => {
    return [`/v1/ProgressBar/project`, ...(params ? [params] : [])] as const;
};

export const useGetProjectProgressBarStatusQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProjectProgressBarStatusHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetProjectProgressBarStatusParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetProjectProgressBarStatusHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetProjectProgressBarStatusQueryKey(params);

    const getProjectProgressBarStatus = useGetProjectProgressBarStatusHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetProjectProgressBarStatusHook>>
        >
    > = () => getProjectProgressBarStatus(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetProjectProgressBarStatusHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetProjectProgressBarStatusQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetProjectProgressBarStatusHook>>>
>;
export type GetProjectProgressBarStatusQueryError = ErrorType<void>;

export function useGetProjectProgressBarStatus<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProjectProgressBarStatusHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetProjectProgressBarStatusParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetProjectProgressBarStatusHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetProjectProgressBarStatusQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetProjectsForEntityHook = () => {
    const getProjectsForEntity = useCustomAxios<ProjectListItemResponse[]>();

    return useCallback(
        (params?: GetProjectsForEntityParams) => {
            return getProjectsForEntity({
                url: `/v1/Project`,
                method: 'GET',
                params,
            });
        },
        [getProjectsForEntity]
    );
};

export const getGetProjectsForEntityQueryKey = (
    params?: GetProjectsForEntityParams
) => {
    return [`/v1/Project`, ...(params ? [params] : [])] as const;
};

export const useGetProjectsForEntityQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>,
    TError = ErrorType<void>
>(
    params?: GetProjectsForEntityParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetProjectsForEntityQueryKey(params);

    const getProjectsForEntity = useGetProjectsForEntityHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>
    > = () => getProjectsForEntity(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetProjectsForEntityQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>
>;
export type GetProjectsForEntityQueryError = ErrorType<void>;

export function useGetProjectsForEntity<
    TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>,
    TError = ErrorType<void>
>(
    params?: GetProjectsForEntityParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetProjectsForEntityHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetProjectsForEntityQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateProjectHook = () => {
    const createProject = useCustomAxios<ProjectListItemResponse>();

    return useCallback(
        (createProjectRequest: CreateProjectRequest) => {
            return createProject({
                url: `/v1/Project`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createProjectRequest,
            });
        },
        [createProject]
    );
};

export const useCreateProjectMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>,
        TError,
        { data: CreateProjectRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>,
    TError,
    { data: CreateProjectRequest },
    TContext
> => {
    const mutationKey = ['createProject'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createProject = useCreateProjectHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>,
        { data: CreateProjectRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createProject(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>
>;
export type CreateProjectMutationBody = CreateProjectRequest;
export type CreateProjectMutationError = ErrorType<void>;

export const useCreateProject = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>,
        TError,
        { data: CreateProjectRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateProjectHook>>>,
    TError,
    { data: CreateProjectRequest },
    TContext
> => {
    const mutationOptions = useCreateProjectMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteProjectHook = () => {
    const deleteProject = useCustomAxios<void>();

    return useCallback(
        (params?: DeleteProjectParams) => {
            return deleteProject({
                url: `/v1/Project`,
                method: 'DELETE',
                params,
            });
        },
        [deleteProject]
    );
};

export const useDeleteProjectMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>,
        TError,
        { params?: DeleteProjectParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>,
    TError,
    { params?: DeleteProjectParams },
    TContext
> => {
    const mutationKey = ['deleteProject'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteProject = useDeleteProjectHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>,
        { params?: DeleteProjectParams }
    > = (props) => {
        const { params } = props ?? {};

        return deleteProject(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteProjectMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>
>;

export type DeleteProjectMutationError = ErrorType<void>;

export const useDeleteProject = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>,
        TError,
        { params?: DeleteProjectParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteProjectHook>>>,
    TError,
    { params?: DeleteProjectParams },
    TContext
> => {
    const mutationOptions = useDeleteProjectMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useUpdateProjectContractValueHook = () => {
    const updateProjectContractValue = useCustomAxios<void>();

    return useCallback(
        (
            updateProjectContractValueBody: number,
            params?: UpdateProjectContractValueParams
        ) => {
            return updateProjectContractValue({
                url: `/v1/Project/contract-value`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: updateProjectContractValueBody,
                params,
            });
        },
        [updateProjectContractValue]
    );
};

export const useUpdateProjectContractValueMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>
        >,
        TError,
        { data: number; params?: UpdateProjectContractValueParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>>,
    TError,
    { data: number; params?: UpdateProjectContractValueParams },
    TContext
> => {
    const mutationKey = ['updateProjectContractValue'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateProjectContractValue = useUpdateProjectContractValueHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>
        >,
        { data: number; params?: UpdateProjectContractValueParams }
    > = (props) => {
        const { data, params } = props ?? {};

        return updateProjectContractValue(data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateProjectContractValueMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>>
>;
export type UpdateProjectContractValueMutationBody = number;
export type UpdateProjectContractValueMutationError = ErrorType<void>;

export const useUpdateProjectContractValue = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>
        >,
        TError,
        { data: number; params?: UpdateProjectContractValueParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectContractValueHook>>>,
    TError,
    { data: number; params?: UpdateProjectContractValueParams },
    TContext
> => {
    const mutationOptions =
        useUpdateProjectContractValueMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useUpdateProjectFinalValueHook = () => {
    const updateProjectFinalValue = useCustomAxios<void>();

    return useCallback(
        (
            updateProjectFinalValueBody: number,
            params?: UpdateProjectFinalValueParams
        ) => {
            return updateProjectFinalValue({
                url: `/v1/Project/final-value`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: updateProjectFinalValueBody,
                params,
            });
        },
        [updateProjectFinalValue]
    );
};

export const useUpdateProjectFinalValueMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>,
        TError,
        { data: number; params?: UpdateProjectFinalValueParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>,
    TError,
    { data: number; params?: UpdateProjectFinalValueParams },
    TContext
> => {
    const mutationKey = ['updateProjectFinalValue'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateProjectFinalValue = useUpdateProjectFinalValueHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>,
        { data: number; params?: UpdateProjectFinalValueParams }
    > = (props) => {
        const { data, params } = props ?? {};

        return updateProjectFinalValue(data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateProjectFinalValueMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>
>;
export type UpdateProjectFinalValueMutationBody = number;
export type UpdateProjectFinalValueMutationError = ErrorType<void>;

export const useUpdateProjectFinalValue = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>,
        TError,
        { data: number; params?: UpdateProjectFinalValueParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectFinalValueHook>>>,
    TError,
    { data: number; params?: UpdateProjectFinalValueParams },
    TContext
> => {
    const mutationOptions = useUpdateProjectFinalValueMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetAllRolesHook = () => {
    const getAllRoles = useCustomAxios<RoleResponse[]>();

    return useCallback(() => {
        return getAllRoles({ url: `/v1/Role/Admin/All`, method: 'GET' });
    }, [getAllRoles]);
};

export const getGetAllRolesQueryKey = () => {
    return [`/v1/Role/Admin/All`] as const;
};

export const useGetAllRolesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllRolesQueryKey();

    const getAllRoles = useGetAllRolesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>
    > = () => getAllRoles();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAllRolesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>
>;
export type GetAllRolesQueryError = ErrorType<unknown>;

export function useGetAllRoles<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAllRolesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetRulesHook = () => {
    const getRules = useCustomAxios<RuleResponse[]>();

    return useCallback(
        (params?: GetRulesParams) => {
            return getRules({ url: `/v1/Rules`, method: 'GET', params });
        },
        [getRules]
    );
};

export const getGetRulesQueryKey = (params?: GetRulesParams) => {
    return [`/v1/Rules`, ...(params ? [params] : [])] as const;
};

export const useGetRulesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRulesQueryKey(params);

    const getRules = useGetRulesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>
    > = () => getRules(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRulesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>
>;
export type GetRulesQueryError = ErrorType<void>;

export function useGetRules<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRulesHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetRulesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateRuleHook = () => {
    const createRule = useCustomAxios<RuleResponse>();

    return useCallback(
        (createRuleRequest: CreateRuleRequest) => {
            return createRule({
                url: `/v1/Rules`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createRuleRequest,
            });
        },
        [createRule]
    );
};

export const useCreateRuleMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>,
        TError,
        { data: CreateRuleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>,
    TError,
    { data: CreateRuleRequest },
    TContext
> => {
    const mutationKey = ['createRule'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createRule = useCreateRuleHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>,
        { data: CreateRuleRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createRule(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateRuleMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>
>;
export type CreateRuleMutationBody = CreateRuleRequest;
export type CreateRuleMutationError = ErrorType<void>;

export const useCreateRule = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>,
        TError,
        { data: CreateRuleRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateRuleHook>>>,
    TError,
    { data: CreateRuleRequest },
    TContext
> => {
    const mutationOptions = useCreateRuleMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetGeneratedFixedAssetRulesHook = () => {
    const getGeneratedFixedAssetRules = useCustomAxios<RuleResponse[]>();

    return useCallback(
        (params?: GetGeneratedFixedAssetRulesParams) => {
            return getGeneratedFixedAssetRules({
                url: `/v1/Rules/generated`,
                method: 'GET',
                params,
            });
        },
        [getGeneratedFixedAssetRules]
    );
};

export const getGetGeneratedFixedAssetRulesQueryKey = (
    params?: GetGeneratedFixedAssetRulesParams
) => {
    return [`/v1/Rules/generated`, ...(params ? [params] : [])] as const;
};

export const useGetGeneratedFixedAssetRulesQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetGeneratedFixedAssetRulesHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetGeneratedFixedAssetRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetGeneratedFixedAssetRulesHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetGeneratedFixedAssetRulesQueryKey(params);

    const getGeneratedFixedAssetRules = useGetGeneratedFixedAssetRulesHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetGeneratedFixedAssetRulesHook>>
        >
    > = () => getGeneratedFixedAssetRules(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetGeneratedFixedAssetRulesHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetGeneratedFixedAssetRulesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetGeneratedFixedAssetRulesHook>>>
>;
export type GetGeneratedFixedAssetRulesQueryError = ErrorType<void>;

export function useGetGeneratedFixedAssetRules<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetGeneratedFixedAssetRulesHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetGeneratedFixedAssetRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetGeneratedFixedAssetRulesHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetGeneratedFixedAssetRulesQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetRuleListHook = () => {
    const getRuleList = useCustomAxios<RuleListItemResponse[]>();

    return useCallback(
        (params?: GetRuleListParams) => {
            return getRuleList({
                url: `/v1/Rules/list`,
                method: 'GET',
                params,
            });
        },
        [getRuleList]
    );
};

export const getGetRuleListQueryKey = (params?: GetRuleListParams) => {
    return [`/v1/Rules/list`, ...(params ? [params] : [])] as const;
};

export const useGetRuleListQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRuleListQueryKey(params);

    const getRuleList = useGetRuleListHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>
    > = () => getRuleList(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRuleListQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>
>;
export type GetRuleListQueryError = ErrorType<void>;

export function useGetRuleList<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleListHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetRuleListQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useEntityHasRulesHook = () => {
    const entityHasRules = useCustomAxios<boolean>();

    return useCallback(
        (params?: EntityHasRulesParams) => {
            return entityHasRules({
                url: `/v1/Rules/exists`,
                method: 'GET',
                params,
            });
        },
        [entityHasRules]
    );
};

export const getEntityHasRulesQueryKey = (params?: EntityHasRulesParams) => {
    return [`/v1/Rules/exists`, ...(params ? [params] : [])] as const;
};

export const useEntityHasRulesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: EntityHasRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getEntityHasRulesQueryKey(params);

    const entityHasRules = useEntityHasRulesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>
    > = () => entityHasRules(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type EntityHasRulesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>
>;
export type EntityHasRulesQueryError = ErrorType<void>;

export function useEntityHasRules<
    TData = Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: EntityHasRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useEntityHasRulesHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useEntityHasRulesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetRuleByIdHook = () => {
    const getRuleById = useCustomAxios<RuleResponse>();

    return useCallback(
        (ruleId: number) => {
            return getRuleById({ url: `/v1/Rules/${ruleId}`, method: 'GET' });
        },
        [getRuleById]
    );
};

export const getGetRuleByIdQueryKey = (ruleId?: number) => {
    return [`/v1/Rules/${ruleId}`] as const;
};

export const useGetRuleByIdQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>,
    TError = ErrorType<void>
>(
    ruleId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRuleByIdQueryKey(ruleId);

    const getRuleById = useGetRuleByIdHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>
    > = () => getRuleById(ruleId);

    return {
        queryKey,
        queryFn,
        enabled: !!ruleId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRuleByIdQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>
>;
export type GetRuleByIdQueryError = ErrorType<void>;

export function useGetRuleById<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>,
    TError = ErrorType<void>
>(
    ruleId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleByIdHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetRuleByIdQueryOptions(ruleId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useUpdateRuleHook = () => {
    const updateRule = useCustomAxios<RuleResponse>();

    return useCallback(
        (ruleId: number, updateRuleRequest: UpdateRuleRequest) => {
            return updateRule({
                url: `/v1/Rules/${ruleId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: updateRuleRequest,
            });
        },
        [updateRule]
    );
};

export const useUpdateRuleMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>,
        TError,
        { ruleId: number; data: UpdateRuleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>,
    TError,
    { ruleId: number; data: UpdateRuleRequest },
    TContext
> => {
    const mutationKey = ['updateRule'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateRule = useUpdateRuleHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>,
        { ruleId: number; data: UpdateRuleRequest }
    > = (props) => {
        const { ruleId, data } = props ?? {};

        return updateRule(ruleId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateRuleMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>
>;
export type UpdateRuleMutationBody = UpdateRuleRequest;
export type UpdateRuleMutationError = ErrorType<void>;

export const useUpdateRule = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>,
        TError,
        { ruleId: number; data: UpdateRuleRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateRuleHook>>>,
    TError,
    { ruleId: number; data: UpdateRuleRequest },
    TContext
> => {
    const mutationOptions = useUpdateRuleMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteRuleHook = () => {
    const deleteRule = useCustomAxios<void>();

    return useCallback(
        (ruleId: number) => {
            return deleteRule({ url: `/v1/Rules/${ruleId}`, method: 'DELETE' });
        },
        [deleteRule]
    );
};

export const useDeleteRuleMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>,
        TError,
        { ruleId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>,
    TError,
    { ruleId: number },
    TContext
> => {
    const mutationKey = ['deleteRule'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteRule = useDeleteRuleHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>,
        { ruleId: number }
    > = (props) => {
        const { ruleId } = props ?? {};

        return deleteRule(ruleId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteRuleMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>
>;

export type DeleteRuleMutationError = ErrorType<void>;

export const useDeleteRule = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>,
        TError,
        { ruleId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteRuleHook>>>,
    TError,
    { ruleId: number },
    TContext
> => {
    const mutationOptions = useDeleteRuleMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetRuleColumnsHook = () => {
    const getRuleColumns = useCustomAxios<RuleColumnResponse[]>();

    return useCallback(
        (params?: GetRuleColumnsParams) => {
            return getRuleColumns({
                url: `/v1/Rules/columns`,
                method: 'GET',
                params,
            });
        },
        [getRuleColumns]
    );
};

export const getGetRuleColumnsQueryKey = (params?: GetRuleColumnsParams) => {
    return [`/v1/Rules/columns`, ...(params ? [params] : [])] as const;
};

export const useGetRuleColumnsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleColumnsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetRuleColumnsQueryKey(params);

    const getRuleColumns = useGetRuleColumnsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>
    > = () => getRuleColumns(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRuleColumnsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>
>;
export type GetRuleColumnsQueryError = ErrorType<void>;

export function useGetRuleColumns<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleColumnsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleColumnsHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetRuleColumnsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetAIRulesHook = () => {
    const getAIRules = useCustomAxios<AIRuleResponse[]>();

    return useCallback(
        (params?: GetAIRulesParams) => {
            return getAIRules({ url: `/v1/Rules/ai`, method: 'GET', params });
        },
        [getAIRules]
    );
};

export const getGetAIRulesQueryKey = (params?: GetAIRulesParams) => {
    return [`/v1/Rules/ai`, ...(params ? [params] : [])] as const;
};

export const useGetAIRulesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetAIRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAIRulesQueryKey(params);

    const getAIRules = useGetAIRulesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>
    > = () => getAIRules(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAIRulesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>
>;
export type GetAIRulesQueryError = ErrorType<void>;

export function useGetAIRules<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>,
    TError = ErrorType<void>
>(
    params?: GetAIRulesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAIRulesHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAIRulesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetRuleBanksHook = () => {
    const getRuleBanks = useCustomAxios<RuleBankResponse[]>();

    return useCallback(
        (params?: GetRuleBanksParams) => {
            return getRuleBanks({
                url: `/v1/Rules/rule-banks`,
                method: 'GET',
                params,
            });
        },
        [getRuleBanks]
    );
};

export const getGetRuleBanksQueryKey = (params?: GetRuleBanksParams) => {
    return [`/v1/Rules/rule-banks`, ...(params ? [params] : [])] as const;
};

export const useGetRuleBanksQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleBanksParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRuleBanksQueryKey(params);

    const getRuleBanks = useGetRuleBanksHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>
    > = () => getRuleBanks(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRuleBanksQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>
>;
export type GetRuleBanksQueryError = ErrorType<void>;

export function useGetRuleBanks<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>,
    TError = ErrorType<void>
>(
    params?: GetRuleBanksParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetRuleBanksHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetRuleBanksQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useAddRuleBankHook = () => {
    const addRuleBank = useCustomAxios<number>();

    return useCallback(
        (params?: AddRuleBankParams) => {
            return addRuleBank({
                url: `/v1/Rules/rule-banks`,
                method: 'POST',
                params,
            });
        },
        [addRuleBank]
    );
};

export const useAddRuleBankMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>,
        TError,
        { params?: AddRuleBankParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>,
    TError,
    { params?: AddRuleBankParams },
    TContext
> => {
    const mutationKey = ['addRuleBank'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const addRuleBank = useAddRuleBankHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>,
        { params?: AddRuleBankParams }
    > = (props) => {
        const { params } = props ?? {};

        return addRuleBank(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddRuleBankMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>
>;

export type AddRuleBankMutationError = ErrorType<void>;

export const useAddRuleBank = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>,
        TError,
        { params?: AddRuleBankParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAddRuleBankHook>>>,
    TError,
    { params?: AddRuleBankParams },
    TContext
> => {
    const mutationOptions = useAddRuleBankMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useRemoveRuleBankHook = () => {
    const removeRuleBank = useCustomAxios<number>();

    return useCallback(
        (params?: RemoveRuleBankParams) => {
            return removeRuleBank({
                url: `/v1/Rules/rule-banks`,
                method: 'DELETE',
                params,
            });
        },
        [removeRuleBank]
    );
};

export const useRemoveRuleBankMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>,
        TError,
        { params?: RemoveRuleBankParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>,
    TError,
    { params?: RemoveRuleBankParams },
    TContext
> => {
    const mutationKey = ['removeRuleBank'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const removeRuleBank = useRemoveRuleBankHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>,
        { params?: RemoveRuleBankParams }
    > = (props) => {
        const { params } = props ?? {};

        return removeRuleBank(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type RemoveRuleBankMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>
>;

export type RemoveRuleBankMutationError = ErrorType<void>;

export const useRemoveRuleBank = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>,
        TError,
        { params?: RemoveRuleBankParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRemoveRuleBankHook>>>,
    TError,
    { params?: RemoveRuleBankParams },
    TContext
> => {
    const mutationOptions = useRemoveRuleBankMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplicationHook = () => {
    const postV1ContactPersonSuperAdminApplication =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createApplicationContactRequest: CreateApplicationContactRequest) => {
            return postV1ContactPersonSuperAdminApplication({
                url: `/v1/ContactPerson/SuperAdmin/Application`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createApplicationContactRequest,
            });
        },
        [postV1ContactPersonSuperAdminApplication]
    );
};

export const usePostV1ContactPersonSuperAdminApplicationMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        TError,
        { data: CreateApplicationContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const mutationKey = ['postV1ContactPersonSuperAdminApplication'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1ContactPersonSuperAdminApplication =
        usePostV1ContactPersonSuperAdminApplicationHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        { data: CreateApplicationContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonSuperAdminApplication(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonSuperAdminApplicationMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >
    >;
export type PostV1ContactPersonSuperAdminApplicationMutationBody =
    CreateApplicationContactRequest;
export type PostV1ContactPersonSuperAdminApplicationMutationError =
    ErrorType<void>;

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplication = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        TError,
        { data: CreateApplicationContactRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonSuperAdminApplicationMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1PolicySuperAdminPolicyIdHook = () => {
    const putV1PolicySuperAdminPolicyId = useCustomAxios<PolicyResponse>();

    return useCallback(
        (policyId: number, editPolicyRequest: EditPolicyRequest) => {
            return putV1PolicySuperAdminPolicyId({
                url: `/v1/Policy/SuperAdmin/${policyId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editPolicyRequest,
            });
        },
        [putV1PolicySuperAdminPolicyId]
    );
};

export const usePutV1PolicySuperAdminPolicyIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        TError,
        { policyId: number; data: EditPolicyRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const mutationKey = ['putV1PolicySuperAdminPolicyId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1PolicySuperAdminPolicyId =
        usePutV1PolicySuperAdminPolicyIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        { policyId: number; data: EditPolicyRequest }
    > = (props) => {
        const { policyId, data } = props ?? {};

        return putV1PolicySuperAdminPolicyId(policyId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1PolicySuperAdminPolicyIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>>
>;
export type PutV1PolicySuperAdminPolicyIdMutationBody = EditPolicyRequest;
export type PutV1PolicySuperAdminPolicyIdMutationError = ErrorType<void>;

export const usePutV1PolicySuperAdminPolicyId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        TError,
        { policyId: number; data: EditPolicyRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1PolicySuperAdminPolicyIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useSuperAdminGetTenantHook = () => {
    const superAdminGetTenant = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number) => {
            return superAdminGetTenant({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'GET',
            });
        },
        [superAdminGetTenant]
    );
};

export const getSuperAdminGetTenantQueryKey = (tenantId?: number) => {
    return [`/v1/Tenant/SuperAdmin/${tenantId}`] as const;
};

export const useSuperAdminGetTenantQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getSuperAdminGetTenantQueryKey(tenantId);

    const superAdminGetTenant = useSuperAdminGetTenantHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>
    > = () => superAdminGetTenant(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SuperAdminGetTenantQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>
>;
export type SuperAdminGetTenantQueryError = ErrorType<void>;

export function useSuperAdminGetTenant<
    TData = Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useSuperAdminGetTenantHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useSuperAdminGetTenantQueryOptions(tenantId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useSuperAdminGetAllTenantsHook = () => {
    const superAdminGetAllTenants = useCustomAxios<PaginatedTenantResponse>();

    return useCallback(
        (params?: SuperAdminGetAllTenantsParams) => {
            return superAdminGetAllTenants({
                url: `/v1/Tenant/SuperAdmin`,
                method: 'GET',
                params,
            });
        },
        [superAdminGetAllTenants]
    );
};

export const getSuperAdminGetAllTenantsQueryKey = (
    params?: SuperAdminGetAllTenantsParams
) => {
    return [`/v1/Tenant/SuperAdmin`, ...(params ? [params] : [])] as const;
};

export const useSuperAdminGetAllTenantsQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>
    >,
    TError = ErrorType<void>
>(
    params?: SuperAdminGetAllTenantsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getSuperAdminGetAllTenantsQueryKey(params);

    const superAdminGetAllTenants = useSuperAdminGetAllTenantsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>>
    > = () => superAdminGetAllTenants(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SuperAdminGetAllTenantsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>>
>;
export type SuperAdminGetAllTenantsQueryError = ErrorType<void>;

export function useSuperAdminGetAllTenants<
    TData = Awaited<
        ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>
    >,
    TError = ErrorType<void>
>(
    params?: SuperAdminGetAllTenantsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useSuperAdminGetAllTenantsHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useSuperAdminGetAllTenantsQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useSuperAdminRestoreTenantHook = () => {
    const superAdminRestoreTenant = useCustomAxios<void>();

    return useCallback(
        (tenantId: number, params?: SuperAdminRestoreTenantParams) => {
            return superAdminRestoreTenant({
                url: `/v1/Tenant/SuperAdmin/restore/${tenantId}`,
                method: 'PUT',
                params,
            });
        },
        [superAdminRestoreTenant]
    );
};

export const useSuperAdminRestoreTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>,
        TError,
        { tenantId: number; params?: SuperAdminRestoreTenantParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>,
    TError,
    { tenantId: number; params?: SuperAdminRestoreTenantParams },
    TContext
> => {
    const mutationKey = ['superAdminRestoreTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const superAdminRestoreTenant = useSuperAdminRestoreTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>,
        { tenantId: number; params?: SuperAdminRestoreTenantParams }
    > = (props) => {
        const { tenantId, params } = props ?? {};

        return superAdminRestoreTenant(tenantId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type SuperAdminRestoreTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>
>;

export type SuperAdminRestoreTenantMutationError = ErrorType<void>;

export const useSuperAdminRestoreTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>,
        TError,
        { tenantId: number; params?: SuperAdminRestoreTenantParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSuperAdminRestoreTenantHook>>>,
    TError,
    { tenantId: number; params?: SuperAdminRestoreTenantParams },
    TContext
> => {
    const mutationOptions = useSuperAdminRestoreTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetActiveTenantInfoHook = () => {
    const getActiveTenantInfo = useCustomAxios<TenantResponse>();

    return useCallback(() => {
        return getActiveTenantInfo({ url: `/v1/Tenant`, method: 'GET' });
    }, [getActiveTenantInfo]);
};

export const getGetActiveTenantInfoQueryKey = () => {
    return [`/v1/Tenant`] as const;
};

export const useGetActiveTenantInfoQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetActiveTenantInfoQueryKey();

    const getActiveTenantInfo = useGetActiveTenantInfoHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>
    > = () => getActiveTenantInfo();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetActiveTenantInfoQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>
>;
export type GetActiveTenantInfoQueryError = ErrorType<void>;

export function useGetActiveTenantInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveTenantInfoHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetActiveTenantInfoQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetAvailableTenantsHook = () => {
    const getAvailableTenants = useCustomAxios<UserTenantResponse[]>();

    return useCallback(() => {
        return getAvailableTenants({
            url: `/v1/Tenant/available`,
            method: 'GET',
        });
    }, [getAvailableTenants]);
};

export const getGetAvailableTenantsQueryKey = () => {
    return [`/v1/Tenant/available`] as const;
};

export const useGetAvailableTenantsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAvailableTenantsQueryKey();

    const getAvailableTenants = useGetAvailableTenantsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>
    > = () => getAvailableTenants();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAvailableTenantsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>
>;
export type GetAvailableTenantsQueryError = ErrorType<void>;

export function useGetAvailableTenants<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableTenantsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAvailableTenantsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useActivateTenantHook = () => {
    const activateTenant = useCustomAxios<ActivateTenantResponse>();

    return useCallback(
        (tenantId: number, activateTenantRequest: ActivateTenantRequest) => {
            return activateTenant({
                url: `/v1/Tenant/${tenantId}/activate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: activateTenantRequest,
            });
        },
        [activateTenant]
    );
};

export const useActivateTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>,
        TError,
        { tenantId: number; data: ActivateTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>,
    TError,
    { tenantId: number; data: ActivateTenantRequest },
    TContext
> => {
    const mutationKey = ['activateTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const activateTenant = useActivateTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>,
        { tenantId: number; data: ActivateTenantRequest }
    > = (props) => {
        const { tenantId, data } = props ?? {};

        return activateTenant(tenantId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ActivateTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>
>;
export type ActivateTenantMutationBody = ActivateTenantRequest;
export type ActivateTenantMutationError = ErrorType<void>;

export const useActivateTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>,
        TError,
        { tenantId: number; data: ActivateTenantRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useActivateTenantHook>>>,
    TError,
    { tenantId: number; data: ActivateTenantRequest },
    TContext
> => {
    const mutationOptions = useActivateTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetActiveConnectionHook = () => {
    const getActiveConnection = useCustomAxios<void>();

    return useCallback(() => {
        return getActiveConnection({
            url: `/v1/Tenant/active-connection`,
            method: 'GET',
        });
    }, [getActiveConnection]);
};

export const getGetActiveConnectionQueryKey = () => {
    return [`/v1/Tenant/active-connection`] as const;
};

export const useGetActiveConnectionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetActiveConnectionQueryKey();

    const getActiveConnection = useGetActiveConnectionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>
    > = () => getActiveConnection();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetActiveConnectionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>
>;
export type GetActiveConnectionQueryError = ErrorType<void>;

export function useGetActiveConnection<
    TData = Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetActiveConnectionHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetActiveConnectionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateTenantHook = () => {
    const createTenant = useCustomAxios<CreateTenantResponse>();

    return useCallback(
        (createTenantRequest: CreateTenantRequest) => {
            return createTenant({
                url: `/v1/Tenant/create`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantRequest,
            });
        },
        [createTenant]
    );
};

export const useCreateTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>,
        TError,
        { data: CreateTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const mutationKey = ['createTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createTenant = useCreateTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>,
        { data: CreateTenantRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createTenant(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>
>;
export type CreateTenantMutationBody = CreateTenantRequest;
export type CreateTenantMutationError = ErrorType<void>;

export const useCreateTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>,
        TError,
        { data: CreateTenantRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateTenantHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const mutationOptions = useCreateTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useUpdateTenantHook = () => {
    const updateTenant = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number, editTenantRequest: EditTenantRequest) => {
            return updateTenant({
                url: `/v1/Tenant/${tenantId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editTenantRequest,
            });
        },
        [updateTenant]
    );
};

export const useUpdateTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>,
        TError,
        { tenantId: number; data: EditTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const mutationKey = ['updateTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateTenant = useUpdateTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>,
        { tenantId: number; data: EditTenantRequest }
    > = (props) => {
        const { tenantId, data } = props ?? {};

        return updateTenant(tenantId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>
>;
export type UpdateTenantMutationBody = EditTenantRequest;
export type UpdateTenantMutationError = ErrorType<void>;

export const useUpdateTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>,
        TError,
        { tenantId: number; data: EditTenantRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateTenantHook>>>,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const mutationOptions = useUpdateTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteTenantHook = () => {
    const deleteTenant = useCustomAxios<void>();

    return useCallback(
        (tenantId: number) => {
            return deleteTenant({
                url: `/v1/Tenant/${tenantId}`,
                method: 'DELETE',
            });
        },
        [deleteTenant]
    );
};

export const useDeleteTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationKey = ['deleteTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteTenant = useDeleteTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>,
        { tenantId: number }
    > = (props) => {
        const { tenantId } = props ?? {};

        return deleteTenant(tenantId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>
>;

export type DeleteTenantMutationError = ErrorType<void>;

export const useDeleteTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteTenantHook>>>,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationOptions = useDeleteTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetTimePeriodsHook = () => {
    const getTimePeriods = useCustomAxios<TimePeriodResponse[]>();

    return useCallback(() => {
        return getTimePeriods({ url: `/v1/TimePeriod`, method: 'GET' });
    }, [getTimePeriods]);
};

export const getGetTimePeriodsQueryKey = () => {
    return [`/v1/TimePeriod`] as const;
};

export const useGetTimePeriodsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimePeriodsQueryKey();

    const getTimePeriods = useGetTimePeriodsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>
    > = () => getTimePeriods();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTimePeriodsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>
>;
export type GetTimePeriodsQueryError = ErrorType<unknown>;

export function useGetTimePeriods<
    TData = Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTimePeriodsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetTimePeriodsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useCreateTimePeriodHook = () => {
    const createTimePeriod = useCustomAxios<TimePeriodResponse>();

    return useCallback(
        (createTimePeriodRequest: CreateTimePeriodRequest) => {
            return createTimePeriod({
                url: `/v1/TimePeriod`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTimePeriodRequest,
            });
        },
        [createTimePeriod]
    );
};

export const useCreateTimePeriodMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>,
        TError,
        { data: CreateTimePeriodRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>,
    TError,
    { data: CreateTimePeriodRequest },
    TContext
> => {
    const mutationKey = ['createTimePeriod'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createTimePeriod = useCreateTimePeriodHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>,
        { data: CreateTimePeriodRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createTimePeriod(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateTimePeriodMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>
>;
export type CreateTimePeriodMutationBody = CreateTimePeriodRequest;
export type CreateTimePeriodMutationError = ErrorType<void>;

export const useCreateTimePeriod = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>,
        TError,
        { data: CreateTimePeriodRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateTimePeriodHook>>>,
    TError,
    { data: CreateTimePeriodRequest },
    TContext
> => {
    const mutationOptions = useCreateTimePeriodMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useActivateTimePeriodHook = () => {
    const activateTimePeriod = useCustomAxios<void>();

    return useCallback(
        (timeId: number) => {
            return activateTimePeriod({
                url: `/v1/TimePeriod/${timeId}/activate`,
                method: 'POST',
            });
        },
        [activateTimePeriod]
    );
};

export const useActivateTimePeriodMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>,
        TError,
        { timeId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>,
    TError,
    { timeId: number },
    TContext
> => {
    const mutationKey = ['activateTimePeriod'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const activateTimePeriod = useActivateTimePeriodHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>,
        { timeId: number }
    > = (props) => {
        const { timeId } = props ?? {};

        return activateTimePeriod(timeId);
    };

    return { mutationFn, ...mutationOptions };
};

export type ActivateTimePeriodMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>
>;

export type ActivateTimePeriodMutationError = ErrorType<void>;

export const useActivateTimePeriod = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>,
        TError,
        { timeId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useActivateTimePeriodHook>>>,
    TError,
    { timeId: number },
    TContext
> => {
    const mutationOptions = useActivateTimePeriodMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetToursHook = () => {
    const getTours = useCustomAxios<void>();

    return useCallback(() => {
        return getTours({ url: `/v1/Tours`, method: 'GET' });
    }, [getTours]);
};

export const getGetToursQueryKey = () => {
    return [`/v1/Tours`] as const;
};

export const useGetToursQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetToursQueryKey();

    const getTours = useGetToursHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>
    > = () => getTours();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetToursQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>
>;
export type GetToursQueryError = ErrorType<void>;

export function useGetTours<
    TData = Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetToursHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetToursQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get the current authenticated user's details.
Maps to old FASORT: fetchCurrentUser()
 */
export const useGetCurrentUserHook = () => {
    const getCurrentUser = useCustomAxios<UserResponse>();

    return useCallback(() => {
        return getCurrentUser({ url: `/v1/User/current-user`, method: 'GET' });
    }, [getCurrentUser]);
};

export const getGetCurrentUserQueryKey = () => {
    return [`/v1/User/current-user`] as const;
};

export const useGetCurrentUserQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

    const getCurrentUser = useGetCurrentUserHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>
    > = () => getCurrentUser();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>
>;
export type GetCurrentUserQueryError = ErrorType<void>;

/**
 * @summary Get the current authenticated user's details.
Maps to old FASORT: fetchCurrentUser()
 */

export function useGetCurrentUser<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetCurrentUserQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all users across all tenants.
 */
export const useGetAllUsersHook = () => {
    const getAllUsers = useCustomAxios<PaginatedAllUserResponse>();

    return useCallback(
        (params?: GetAllUsersParams) => {
            return getAllUsers({ url: `/v1/User/all`, method: 'GET', params });
        },
        [getAllUsers]
    );
};

export const getGetAllUsersQueryKey = (params?: GetAllUsersParams) => {
    return [`/v1/User/all`, ...(params ? [params] : [])] as const;
};

export const useGetAllUsersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>,
    TError = ErrorType<void>
>(
    params?: GetAllUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllUsersQueryKey(params);

    const getAllUsers = useGetAllUsersHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>
    > = () => getAllUsers(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAllUsersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>
>;
export type GetAllUsersQueryError = ErrorType<void>;

/**
 * @summary Get all users across all tenants.
 */

export function useGetAllUsers<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>,
    TError = ErrorType<void>
>(
    params?: GetAllUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetAllUsersHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAllUsersQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all tenants the current user has access to.
Maps to old FASORT: fetchTenanciesForUser()
 */
export const useGetUserTenantsHook = () => {
    const getUserTenants = useCustomAxios<CurrentUserTenantResponse[]>();

    return useCallback(() => {
        return getUserTenants({ url: `/v1/User/tenants`, method: 'GET' });
    }, [getUserTenants]);
};

export const getGetUserTenantsQueryKey = () => {
    return [`/v1/User/tenants`] as const;
};

export const useGetUserTenantsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserTenantsQueryKey();

    const getUserTenants = useGetUserTenantsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>
    > = () => getUserTenants();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserTenantsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>
>;
export type GetUserTenantsQueryError = ErrorType<void>;

/**
 * @summary Get all tenants the current user has access to.
Maps to old FASORT: fetchTenanciesForUser()
 */

export function useGetUserTenants<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserTenantsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUserTenantsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get users available to be added to the current tenant.
Maps to old FASORT: fetchUsersForTenancyShare(tenantID)
 */
export const useGetAvailableUsersHook = () => {
    const getAvailableUsers = useCustomAxios<AvaibleUserInTenantResponse[]>();

    return useCallback(() => {
        return getAvailableUsers({ url: `/v1/User/available`, method: 'GET' });
    }, [getAvailableUsers]);
};

export const getGetAvailableUsersQueryKey = () => {
    return [`/v1/User/available`] as const;
};

export const useGetAvailableUsersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAvailableUsersQueryKey();

    const getAvailableUsers = useGetAvailableUsersHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>
    > = () => getAvailableUsers();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAvailableUsersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>
>;
export type GetAvailableUsersQueryError = ErrorType<void>;

/**
 * @summary Get users available to be added to the current tenant.
Maps to old FASORT: fetchUsersForTenancyShare(tenantID)
 */

export function useGetAvailableUsers<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAvailableUsersHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAvailableUsersQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all users linked to a specific tenant.
Maps to old FASORT: fetchUsersForTenancyShare(tenantID) — returns users for a tenant.
 */
export const useGetUsersForTenantHook = () => {
    const getUsersForTenant = useCustomAxios<UserResponse[]>();

    return useCallback(
        (tenantId: number) => {
            return getUsersForTenant({
                url: `/v1/User/tenant/${tenantId}`,
                method: 'GET',
            });
        },
        [getUsersForTenant]
    );
};

export const getGetUsersForTenantQueryKey = (tenantId?: number) => {
    return [`/v1/User/tenant/${tenantId}`] as const;
};

export const useGetUsersForTenantQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersForTenantQueryKey(tenantId);

    const getUsersForTenant = useGetUsersForTenantHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>
    > = () => getUsersForTenant(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUsersForTenantQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>
>;
export type GetUsersForTenantQueryError = ErrorType<void>;

/**
 * @summary Get all users linked to a specific tenant.
Maps to old FASORT: fetchUsersForTenancyShare(tenantID) — returns users for a tenant.
 */

export function useGetUsersForTenant<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetUsersForTenantHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUsersForTenantQueryOptions(tenantId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all available roles.
Maps to old FASORT: fetchRolesForTenancyShare()
 */
export const useGetUserRolesHook = () => {
    const getUserRoles = useCustomAxios<RoleResponse[]>();

    return useCallback(() => {
        return getUserRoles({ url: `/v1/User/roles`, method: 'GET' });
    }, [getUserRoles]);
};

export const getGetUserRolesQueryKey = () => {
    return [`/v1/User/roles`] as const;
};

export const useGetUserRolesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserRolesQueryKey();

    const getUserRoles = useGetUserRolesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>
    > = () => getUserRoles();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserRolesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>
>;
export type GetUserRolesQueryError = ErrorType<unknown>;

/**
 * @summary Get all available roles.
Maps to old FASORT: fetchRolesForTenancyShare()
 */

export function useGetUserRoles<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUserRolesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Add user to a tenant (share engagement access).
Maps to old FASORT: addUserShare(parentTenancyID, principalID, roleLevelID)
 */
export const useAddUserToTenantHook = () => {
    const addUserToTenant = useCustomAxios<UserResponse>();

    return useCallback(
        (userId: number, tenantId: number, params?: AddUserToTenantParams) => {
            return addUserToTenant({
                url: `/v1/User/${userId}/tenant/${tenantId}`,
                method: 'POST',
                params,
            });
        },
        [addUserToTenant]
    );
};

export const useAddUserToTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>,
        TError,
        { userId: number; tenantId: number; params?: AddUserToTenantParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>,
    TError,
    { userId: number; tenantId: number; params?: AddUserToTenantParams },
    TContext
> => {
    const mutationKey = ['addUserToTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const addUserToTenant = useAddUserToTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>,
        { userId: number; tenantId: number; params?: AddUserToTenantParams }
    > = (props) => {
        const { userId, tenantId, params } = props ?? {};

        return addUserToTenant(userId, tenantId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddUserToTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>
>;

export type AddUserToTenantMutationError = ErrorType<void>;

/**
 * @summary Add user to a tenant (share engagement access).
Maps to old FASORT: addUserShare(parentTenancyID, principalID, roleLevelID)
 */
export const useAddUserToTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>,
        TError,
        { userId: number; tenantId: number; params?: AddUserToTenantParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAddUserToTenantHook>>>,
    TError,
    { userId: number; tenantId: number; params?: AddUserToTenantParams },
    TContext
> => {
    const mutationOptions = useAddUserToTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Create a new user (get-or-create by email, idempotent).
Maps to old FASORT: setUser(userEmail, role) — spSetUser stored procedure.
GAP: Old code was idempotent (returned existing user if found).
     New code throws if email already exists. Consider aligning behaviour.
 */
export const useCreateUserHook = () => {
    const createUser = useCustomAxios<UserResponse>();

    return useCallback(
        (params?: CreateUserParams) => {
            return createUser({ url: `/v1/User`, method: 'POST', params });
        },
        [createUser]
    );
};

export const useCreateUserMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
        TError,
        { params?: CreateUserParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
    TError,
    { params?: CreateUserParams },
    TContext
> => {
    const mutationKey = ['createUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createUser = useCreateUserHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
        { params?: CreateUserParams }
    > = (props) => {
        const { params } = props ?? {};

        return createUser(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>
>;

export type CreateUserMutationError = ErrorType<void>;

/**
 * @summary Create a new user (get-or-create by email, idempotent).
Maps to old FASORT: setUser(userEmail, role) — spSetUser stored procedure.
GAP: Old code was idempotent (returned existing user if found).
     New code throws if email already exists. Consider aligning behaviour.
 */
export const useCreateUser = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
        TError,
        { params?: CreateUserParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
    TError,
    { params?: CreateUserParams },
    TContext
> => {
    const mutationOptions = useCreateUserMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Set the active tenancy for the current user session.
Maps to old FASORT: userDidSelectTenant(tenantID, userRole)
GAP: Not yet implemented in service layer. Needs Redis cache update.
 */
export const useSelectTenantHook = () => {
    const selectTenant = useCustomAxios<void>();

    return useCallback(
        (tenantId: number) => {
            return selectTenant({
                url: `/v1/User/select-tenant/${tenantId}`,
                method: 'POST',
            });
        },
        [selectTenant]
    );
};

export const useSelectTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationKey = ['selectTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const selectTenant = useSelectTenantHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>,
        { tenantId: number }
    > = (props) => {
        const { tenantId } = props ?? {};

        return selectTenant(tenantId);
    };

    return { mutationFn, ...mutationOptions };
};

export type SelectTenantMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>
>;

export type SelectTenantMutationError = ErrorType<void>;

/**
 * @summary Set the active tenancy for the current user session.
Maps to old FASORT: userDidSelectTenant(tenantID, userRole)
GAP: Not yet implemented in service layer. Needs Redis cache update.
 */
export const useSelectTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSelectTenantHook>>>,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationOptions = useSelectTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a tenantId from which the users are retrieved
 */
export const useAdminGetAllUsersHook = () => {
    const adminGetAllUsers = useCustomAxios<PaginatedUserResponse>();

    return useCallback(
        (params?: AdminGetAllUsersParams) => {
            return adminGetAllUsers({
                url: `/v1/User/Admin`,
                method: 'GET',
                params,
            });
        },
        [adminGetAllUsers]
    );
};

export const getAdminGetAllUsersQueryKey = (
    params?: AdminGetAllUsersParams
) => {
    return [`/v1/User/Admin`, ...(params ? [params] : [])] as const;
};

export const useAdminGetAllUsersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>,
    TError = ErrorType<void>
>(
    params?: AdminGetAllUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminGetAllUsersQueryKey(params);

    const adminGetAllUsers = useAdminGetAllUsersHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>
    > = () => adminGetAllUsers(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type AdminGetAllUsersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>
>;
export type AdminGetAllUsersQueryError = ErrorType<void>;

/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a tenantId from which the users are retrieved
 */

export function useAdminGetAllUsers<
    TData = Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>,
    TError = ErrorType<void>
>(
    params?: AdminGetAllUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useAdminGetAllUsersHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useAdminGetAllUsersQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit an existing user
 */
export const useAdminEditUserHook = () => {
    const adminEditUser = useCustomAxios<UserResponse>();

    return useCallback(
        (userId: number, editUserRequest: EditUserRequest) => {
            return adminEditUser({
                url: `/v1/User/Admin/${userId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editUserRequest,
            });
        },
        [adminEditUser]
    );
};

export const useAdminEditUserMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>,
        TError,
        { userId: number; data: EditUserRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const mutationKey = ['adminEditUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const adminEditUser = useAdminEditUserHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>,
        { userId: number; data: EditUserRequest }
    > = (props) => {
        const { userId, data } = props ?? {};

        return adminEditUser(userId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AdminEditUserMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>
>;
export type AdminEditUserMutationBody = EditUserRequest;
export type AdminEditUserMutationError = ErrorType<void>;

/**
 * @summary Edit an existing user
 */
export const useAdminEditUser = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>,
        TError,
        { userId: number; data: EditUserRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAdminEditUserHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const mutationOptions = useAdminEditUserMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Soft delete an existing user
 */
export const useAdminDeleteUserHook = () => {
    const adminDeleteUser = useCustomAxios<void>();

    return useCallback(
        (userId: number) => {
            return adminDeleteUser({
                url: `/v1/User/Admin/${userId}`,
                method: 'DELETE',
            });
        },
        [adminDeleteUser]
    );
};

export const useAdminDeleteUserMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationKey = ['adminDeleteUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const adminDeleteUser = useAdminDeleteUserHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return adminDeleteUser(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type AdminDeleteUserMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>
>;

export type AdminDeleteUserMutationError = ErrorType<void>;

/**
 * @summary Soft delete an existing user
 */
export const useAdminDeleteUser = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAdminDeleteUserHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions = useAdminDeleteUserMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Restore deleted user
 */
export const useAdminRestoreUserHook = () => {
    const adminRestoreUser = useCustomAxios<void>();

    return useCallback(
        (userId: number) => {
            return adminRestoreUser({
                url: `/v1/User/Admin/restore/${userId}`,
                method: 'PUT',
            });
        },
        [adminRestoreUser]
    );
};

export const useAdminRestoreUserMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationKey = ['adminRestoreUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const adminRestoreUser = useAdminRestoreUserHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return adminRestoreUser(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type AdminRestoreUserMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>
>;

export type AdminRestoreUserMutationError = ErrorType<void>;

/**
 * @summary Restore deleted user
 */
export const useAdminRestoreUser = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAdminRestoreUserHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions = useAdminRestoreUserMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetUserPreferencesHook = () => {
    const getUserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(() => {
        return getUserPreferences({
            url: `/v1/User/Preferences`,
            method: 'GET',
        });
    }, [getUserPreferences]);
};

export const getGetUserPreferencesQueryKey = () => {
    return [`/v1/User/Preferences`] as const;
};

export const useGetUserPreferencesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserPreferencesQueryKey();

    const getUserPreferences = useGetUserPreferencesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>
    > = () => getUserPreferences();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserPreferencesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>
>;
export type GetUserPreferencesQueryError = ErrorType<void>;

export function useGetUserPreferences<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserPreferencesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUserPreferencesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useUpdateUserPreferencesHook = () => {
    const updateUserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(
        (userPreferencesRequest: UserPreferencesRequest) => {
            return updateUserPreferences({
                url: `/v1/User/Preferences`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: userPreferencesRequest,
            });
        },
        [updateUserPreferences]
    );
};

export const useUpdateUserPreferencesMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>,
        TError,
        { data: UserPreferencesRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const mutationKey = ['updateUserPreferences'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateUserPreferences = useUpdateUserPreferencesHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>,
        { data: UserPreferencesRequest }
    > = (props) => {
        const { data } = props ?? {};

        return updateUserPreferences(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateUserPreferencesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>
>;
export type UpdateUserPreferencesMutationBody = UserPreferencesRequest;
export type UpdateUserPreferencesMutationError = ErrorType<void>;

export const useUpdateUserPreferences = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>,
        TError,
        { data: UserPreferencesRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const mutationOptions = useUpdateUserPreferencesMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useAddUserTourHook = () => {
    const addUserTour = useCustomAxios<void>();

    return useCallback(
        (addUserTourBody: string) => {
            return addUserTour({
                url: `/v1/UserTours/add-user-tour`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: addUserTourBody,
            });
        },
        [addUserTour]
    );
};

export const useAddUserTourMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>,
        TError,
        { data: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>,
    TError,
    { data: string },
    TContext
> => {
    const mutationKey = ['addUserTour'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const addUserTour = useAddUserTourHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>,
        { data: string }
    > = (props) => {
        const { data } = props ?? {};

        return addUserTour(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddUserTourMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>
>;
export type AddUserTourMutationBody = string;
export type AddUserTourMutationError = ErrorType<void>;

export const useAddUserTour = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>,
        TError,
        { data: string },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAddUserTourHook>>>,
    TError,
    { data: string },
    TContext
> => {
    const mutationOptions = useAddUserTourMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetUserToursHook = () => {
    const getUserTours = useCustomAxios<void>();

    return useCallback(() => {
        return getUserTours({
            url: `/v1/UserTours/get-user-tours`,
            method: 'GET',
        });
    }, [getUserTours]);
};

export const getGetUserToursQueryKey = () => {
    return [`/v1/UserTours/get-user-tours`] as const;
};

export const useGetUserToursQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserToursQueryKey();

    const getUserTours = useGetUserToursHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>
    > = () => getUserTours();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserToursQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>
>;
export type GetUserToursQueryError = ErrorType<void>;

export function useGetUserTours<
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetUserToursHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetUserToursQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetVersionHook = () => {
    const getVersion = useCustomAxios<ApplicationVersionResponse>();

    return useCallback(() => {
        return getVersion({ url: `/v1/Version`, method: 'GET' });
    }, [getVersion]);
};

export const getGetVersionQueryKey = () => {
    return [`/v1/Version`] as const;
};

export const useGetVersionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetVersionQueryKey();

    const getVersion = useGetVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>
    > = () => getVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>
>;
export type GetVersionQueryError = ErrorType<unknown>;

export function useGetVersion<
    TData = Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetVersionHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetVersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
}
